import type { ItemType } from './Sidebar';

export const getItemsPath = (items: ItemType[]) =>
  items
    .map(({ link }) => link)
    .reduce((acc, cur) => (cur ? [...acc, cur] : acc), []);
